import { gql } from "@apollo/client";

const UPDATE_COS = gql`
  mutation updateCos(
    $cosID: String!
    $title: String
    $activityType: String
    $arrivalDate: String
    $comment: String
    $departureDate: String
    $omobilityId: String
    $receivingAcademicYearId: String
    $receivingHeiId: String
    $sendingAcademicTermEwp: String
    $sendingHeiId: String
    $studentDateOfBirth: String
    $studentEmail: String
    $studentFamilyName: String
    $studentGivenNames: String
    $studentGlobalId: String
  ) {
    updateCos(
      cosID: $cosID
      title: $title
      activityType: $activityType
      arrivalDate: $arrivalDate
      comment: $comment
      departureDate: $departureDate
      omobilityId: $omobilityId
      receivingAcademicYearId: $receivingAcademicYearId
      receivingHeiId: $receivingHeiId
      sendingAcademicTermEwp: $sendingAcademicTermEwp
      sendingHeiId: $sendingHeiId
      studentDateOfBirth: $studentDateOfBirth
      studentEmail: $studentEmail
      studentFamilyName: $studentFamilyName
      studentGivenNames: $studentGivenNames
      studentGlobalId: $studentGlobalId
    )
  }
`;

export default UPDATE_COS;
